import React from "react";
import "./App.css";
import CacheBuster from './CacheBuster';
import { Routes, Route } from "react-router-dom";
import { PortalLoader } from "./ClientPortal/PortalLoader";
import { DisplayScreenLoader } from "./displayScreen/DisplayScreenLoader";
import { WidgetLoader } from "./WidgetLoader";
import { HeyCentricResultHandler } from "./ClientPortal/Payments/HeyCentricResultHandler";
import { PaymentPageLoader } from "./PaymentPageLoader";
import { WidgetV1 } from "./WidgetV1";
import { PayResultHandler } from "./ClientPortal/Payments/PayResultHandler";
import { PortalRedirectLoader } from "./ClientPortal/PortalRedirectLoader";
import { BookingWidgetAuthenticationContextProvider } from "./Authentication/context/useBookingWidgetAuthentication";
import CircularProgress from '@mui/material/CircularProgress';

function App() {

    return (
        // run npm version patch / minor / major - to update version number and force cache update
        <CacheBuster>
            {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                if (loading) return null;
                if (!loading && !isLatestVersion) {
               //     refreshCacheAndReload();
                }

                return (
                    <BookingWidgetAuthenticationContextProvider>
                        <Routes>
                            <Route exact path="/auth-callback" element={<CircularProgress/>} />
                            <Route exact path="/logout" element={<CircularProgress />} />

                            <Route exact path="/Booking/" element={<PortalRedirectLoader />} />
                            <Route path="/payresult/" element={<PayResultHandler />} />
                            <Route path="/heycentricresult/" element={<HeyCentricResultHandler />} />
                            <Route exact path="/Payment/*" element={<PaymentPageLoader />} />
                            <Route exact path="/Booking/:bookingRef" element={<PortalRedirectLoader />} />
                            <Route exact path="/Booking/:email/:bookingref" element={<PortalRedirectLoader />} />
                            <Route exact path="/Screen/:widgetKey/" element={<DisplayScreenLoader />} />
                            <Route path="/Portal/:client/*" element={<PortalLoader />} />
                            <Route path="/widget/*" element={<WidgetLoader />} />
                            <Route exact path="/" element={<WidgetV1 />} />
                            <Route path="/:widgetKey//*" element={<WidgetV1 />} />
                        </Routes>
                    </BookingWidgetAuthenticationContextProvider>
                );
            }}
        </CacheBuster>
    );
};

export default App;
